import React from "react";
import AssetTable from "./detailsAssetTable";
import DetailsTable from "./detailsTable";
import GraphComponent from "./graphComponent";

const DetailsComponent = ({
  viewDetails,
  viewInnerDetails,
  selectedDetail,
  setSelectedDetail,
  selectedAsset,
  setSelectedAsset,
  graphData,
  graphDetails,
  groupsData
}) => {
  return (
    <div>
      {!selectedAsset && (
        <AssetTable
          viewAssetDetails={viewDetails}
          onSelectAsset={setSelectedAsset}
        />
      )}

      {selectedAsset && !selectedDetail && (
        <DetailsTable
          viewInnerDetails={viewInnerDetails}
          onBack={() => setSelectedAsset(null)}
          onSelectDetail={setSelectedDetail}
          groupsData={groupsData}
        />
      )}

      {selectedAsset && !selectedDetail && (
        <GraphComponent
          graphDetails={viewInnerDetails}
          onBack={() => setSelectedDetail(null)}
          groupsData={groupsData}
        />
      )}
    </div>
  );
};

export default DetailsComponent;